module.exports = __webpack_public_path__ + "static/media/warehouse.ce25c08c.svg";